'use strict';

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var web3Utils = require('web3-utils');

var params_1 = require("./params");

__export(require("./params"));

__export(require("./option-formatters"));

exports.calcIntrinsicGas = function (tx) {
  var totalGas = params_1.params.TxGas; // calculate data gas

  if (tx.data) {
    var buffer = new Buffer(exports.sanitizeHex(tx.data), 'hex');
    var z = 0;
    var nz = 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = buffer[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var byte = _step.value;

        if (byte) {
          nz++;
        } else {
          z++;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    totalGas += params_1.params.TxDataZeroGas * z;
    totalGas += params_1.params.TxDataNonZeroGas * nz;
  }

  if (!!tx.to) {
    totalGas += params_1.params.ClauseGas;
  } else {
    totalGas += params_1.params.ClauseGasContractCreation;
  }

  return totalGas;
};

exports.toPrefixedHex = function (hexStr) {
  if (hexStr.indexOf('0x') === 0) {
    return hexStr;
  } else {
    return '0x' + hexStr;
  }
};

exports.sanitizeHex = function (hexStr) {
  if (hexStr.indexOf('0x') === 0) {
    return hexStr.substr(2);
  } else {
    return hexStr;
  }
};

exports.isHex = function (hex) {
  return !!hex && typeof hex === 'string' && /^(-0x|0x)?[0-9a-f]+$/i.test(hex);
};

exports.newNonce = function () {
  return Math.floor(new Date().getTime() / 0xffff * Math.random() * 0xffff);
};

exports.toInteger = function (input) {
  var num = Number.parseInt(input);

  if (Number.isInteger(num)) {
    return num;
  } else {
    return null;
  }
};

exports.isArray = function (o) {
  return Object.prototype.toString.call(o) === '[object Array]';
};

exports.isObject = function (o) {
  return Object.prototype.toString.call(o) === '[object Object]';
};

exports.isNull = function (o) {
  return Object.prototype.toString.call(o) === '[object Null]';
};

exports.isUndefined = function (o) {
  return Object.prototype.toString.call(o) === '[object Undefined]';
};

exports.isFunction = function (o) {
  return typeof o === 'function';
};

exports.mustToBN = function (value) {
  if (exports.isNull(value) || exports.isUndefined(value)) {
    throw new Error('input can\'t be null or undefined');
  }

  var num = web3Utils.toBN(value);
  return num.abs();
};

exports.validNumberOrDefault = function (value, defaultValue) {
  if (typeof value === 'number' && Number.isInteger(value)) {
    return Math.abs(value);
  }

  if (Number.isNaN(Number.parseInt(value)) === false) {
    return Math.abs(Number.parseInt(value));
  }

  return defaultValue;
};

exports.validAddressOrError = function (input) {
  var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Invalid address string';

  if (/^(-0x|0x)?[0-9a-fA-F]{40}$/i.test(input)) {
    return exports.toPrefixedHex(input);
  } else {
    throw new Error(msg);
  }
};

exports.validBytes32OrError = function (input) {
  var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Invalid hex string';

  if (/^(-0x|0x)?[0-9a-fA-F]{64}$/i.test(input)) {
    return exports.toPrefixedHex(input);
  } else {
    throw new Error(msg);
  }
};

exports.leftPadToBytes32 = function (input) {
  return '0x' + '0'.repeat(64 - exports.sanitizeHex(input).length) + exports.sanitizeHex(input);
};